import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GenericAsyncValidator } from './generic-async.validator';
import { RangeValidator } from './range.validator';
import { UniqueValidator } from './unique.validator';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    GenericAsyncValidator,
    RangeValidator,
    UniqueValidator,
  ],
  exports: [
    GenericAsyncValidator,
    RangeValidator,
    UniqueValidator,
  ],
})
export class CustomValidatorModule { }
